<div class="flex items-center gap-1">
  @for (badge of badgeData().slice(0, displayedIconsCount()); track badge.id) {
    <app-social-badge
      [type]="badge.platform"
      [size]="size() === 16 ? (isYoutube(badge.platform) ? 20 : 16) : size()"
      [iconSize]="iconSize() === 16 ? (isYoutube(badge.platform) ? 20 : 16) : iconSize()"
      [title]="badge.platformCreatorId"
      [borderWidth]="borderWidth()"
      [backgroundColor]="backgroundColor()"
      [showTooltip]="showTooltip()"
    />
  }

  @if (hasMoreIcons()) {
    <div class="badge-more">
      <app-icon-badge
        backgroundColor="var(--shikenso-purple-base)"
        fallbackBackgroundColor="var(--shikenso-purple-base)"
        color="var(--shikenso-base-white)"
        matTooltipPosition="above"
        matTooltipClass="comma-break-tooltip"
        [content]="moreIconsCount()"
        [borderWidth]="borderWidth()"
        [size]="size()"
        [iconSize]="moreIconsCountFontSize()"
        [shortenText]="false"
        [matTooltip]="moreIconsTooltip()"
      />
    </div>
  }
</div>
